/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { NbPasswordAuthStrategy, NbAuthOAuth2JWTToken, NbAuthJWTToken } from '@nebular/auth';
import { environment } from '../../environments/environment';

export const authOptions = {
  strategies: [
    NbPasswordAuthStrategy.setup({
      name: 'email',
      baseEndpoint: environment.apiUrl,
      token: {
        class: NbAuthOAuth2JWTToken,
        key: 'token', // this parameter tells where to look for the token
      },
      login: {
        endpoint: '/auth/login',
        method: 'post',
        requireValidToken: true,
      },
      logout: {
        endpoint: '/auth/sign-out',
        redirect: {
          success: '/auth/login',
          failure: '/auth/login'
        },
        method: 'delete'
      },
      requestPass: {
        endpoint: '/auth/request-pass',
        method: 'post'
      },
      resetPass: {
        endpoint: '/auth/reset-pass',
        method: 'post'
      },
      refreshToken: {
        endpoint: '/auth/refresh-token',
        method: 'post',
        requireValidToken: true,
      },
      errors: {
        // Override the getter of errors functions
        // res: is the HttpResponse that you get from your backend 
        getter: (module, res, options) => {
          return res.error ? res.error.message : options[module].defaultErrors;
        },
      },
    }),
  ],
  forms: {
    login: {
      redirectDelay: 2000,
      rememberMe: false,
    },
    register: {
      redirectDelay: 2000,
    },
    logout: {
      redirectDelay: 2000,
    },
    requestPass: {
      redirectDelay: 2000,
    },
    resetPass: {
      redirectDelay: 2000,
    }
  },
  validation: {
    password: {
      required: true,
      minLength: 6,
      maxLength: 50,
    },
    email: {
      required: true,
    }
  },
};
